(function () {
  function initProduct(root) {
    if (!root || root.dataset.haProductReady === "true") return;
    root.dataset.haProductReady = "true";

    initGallery(root);
    initVariants(root);
    initQuantity(root);
    initStickyBar(root);
    initSubnav(root);
    initFitmentDetailsWhenReady(root);
  }

  function initGallery(root) {
    var main = root.querySelector("[data-ha-main-image]");
    var video = root.querySelector("[data-ha-main-video]");
    var embed = root.querySelector("[data-ha-main-embed]");
    var thumbs = Array.prototype.slice.call(root.querySelectorAll("[data-ha-thumb]"));
    var strip = root.querySelector("[data-ha-thumb-strip]");
    var shell = root.querySelector("[data-ha-thumb-shell]");
    var progress = root.querySelector("[data-ha-gallery-progress]");
    if (!main || !thumbs.length) return;
    var activeIndex = Math.max(0, thumbs.findIndex(function (thumb) {
      return thumb.getAttribute("aria-current") === "true";
    }));

    function setActive(button, shouldScroll) {
      thumbs.forEach(function (thumb) {
        thumb.removeAttribute("aria-current");
      });
      button.setAttribute("aria-current", "true");
      activeIndex = thumbs.indexOf(button);
      if (progress) {
        progress.value = String(activeIndex);
        progress.setAttribute("aria-valuetext", "Product media " + String(activeIndex + 1) + " of " + String(thumbs.length));
      }
      if (shouldScroll && typeof button.scrollIntoView === "function") {
        button.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
      }
    }

    function hideEmbed() {
      if (embed) {
        embed.hidden = true;
        embed.removeAttribute("src");
      }
    }

    function showImage(src, isPhoto, button) {
      if (!src) return;
      hideEmbed();
      if (video) {
        video.hidden = true;
        video.pause();
        video.removeAttribute("src");
        video.load();
      }
      main.hidden = false;
      main.src = src;
      main.classList.toggle("is-photo", isPhoto);
      if (button) setActive(button, true);
    }

    function showEmbed(src, button) {
      if (!embed || !src) return;
      main.hidden = true;
      if (video) {
        video.hidden = true;
        video.pause();
        video.removeAttribute("src");
        video.load();
      }
      embed.hidden = false;
      if (embed.getAttribute("src") !== src) embed.setAttribute("src", src + "?autoplay=1");
      if (button) setActive(button, true);
    }

    function showVideo(src, poster, button) {
      if (!video || !src) return;
      hideEmbed();
      main.hidden = true;
      video.hidden = false;
      if (poster) video.setAttribute("poster", poster);
      if (video.getAttribute("src") !== src) {
        video.setAttribute("src", src);
        video.load();
      }
      if (button) setActive(button, true);
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(function () {});
      }
    }

    function showAt(index) {
      if (!thumbs.length) return;
      var next = (index + thumbs.length) % thumbs.length;
      var button = thumbs[next];
      if (button.dataset.embed) {
        showEmbed(button.dataset.embed, button);
      } else if (button.dataset.video) {
        showVideo(button.dataset.video, button.dataset.poster, button);
      } else {
        showImage(button.dataset.src, button.dataset.photo === "true", button);
      }
    }

    thumbs.forEach(function (button) {
      button.addEventListener("click", function () {
        if (button.dataset.embed) {
          showEmbed(button.dataset.embed, button);
        } else if (button.dataset.video) {
          showVideo(button.dataset.video, button.dataset.poster, button);
        } else {
          showImage(button.dataset.src, button.dataset.photo === "true", button);
        }
      });
    });

    root.querySelectorAll("[data-ha-gallery-step]").forEach(function (button) {
      button.addEventListener("click", function () {
        showAt(activeIndex + Number(button.dataset.haGalleryStep || 0));
      });
    });

    if (strip && shell) {
      var stripButtons = Array.prototype.slice.call(root.querySelectorAll("[data-ha-strip-step]"));

      function updateStrip() {
        var hasOverflow = strip.scrollWidth > strip.clientWidth + 2;
        shell.classList.toggle("has-overflow", hasOverflow);
        stripButtons.forEach(function (button) {
          button.disabled = !hasOverflow;
          button.setAttribute("aria-disabled", hasOverflow ? "false" : "true");
        });
      }

      stripButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          strip.scrollBy({
            left: Number(button.dataset.haStripStep || 0) * Math.max(120, strip.clientWidth * 0.72),
            behavior: "smooth"
          });
        });
      });

      if (progress) {
        progress.addEventListener("input", function () {
          showAt(Number(progress.value));
        });
      }

      strip.addEventListener("scroll", updateStrip, { passive: true });
      window.addEventListener("resize", updateStrip, { passive: true });
      updateStrip();
      window.setTimeout(updateStrip, 250);
    }

    if (progress) {
      progress.max = String(Math.max(0, thumbs.length - 1));
      progress.value = String(activeIndex);
      progress.setAttribute("aria-valuetext", "Product media " + String(activeIndex + 1) + " of " + String(thumbs.length));
    }

    var hear = root.querySelector("[data-ha-hear]");
    var videoThumb = root.querySelector("[data-ha-thumb][data-video]");
    if (hear && videoThumb) {
      hear.addEventListener("click", function () {
        videoThumb.click();
        var stage = root.querySelector(".gallery__main");
        if (stage) stage.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    }
  }

  function initVariants(root) {
    var form = root.querySelector("[data-ha-product-form]");
    var hiddenId = form ? form.querySelector("[data-ha-variant-id]") : null;
    var priceTargets = Array.prototype.slice.call(root.querySelectorAll("[data-ha-price]"));
    var compareTarget = root.querySelector("[data-ha-compare]");
    var saveTarget = root.querySelector("[data-ha-save]");
    var note = root.querySelector("[data-ha-stock-note]");
    var status = root.querySelector("[data-ha-variant-status]");
    var barVariant = root.querySelector("[data-ha-bar-variant]");
    var barImage = root.querySelector("[data-ha-bar-image]");
    var submitButtons = Array.prototype.slice.call(root.querySelectorAll("[data-ha-submit]"));
    var wrap = root.querySelector("[data-ha-variants]");

    // Single-variant products render no picker and stay purchasable as-is.
    if (!wrap) return;

    var matrix;
    try {
      matrix = JSON.parse(wrap.querySelector("[data-ha-variant-matrix]").textContent);
    } catch (error) {
      return;
    }

    var optionNames = matrix.options || [];
    var variants = (matrix.variants || []).filter(function (variant) {
      return variant && variant.options && variant.options.length === optionNames.length;
    });
    var selects = Array.prototype.slice.call(wrap.querySelectorAll("[data-ha-option-select]"));
    if (!selects.length || !variants.length) return;

    // Shopify's own value order, captured once before any redraw.
    var valueOrder = selects.map(function (select) {
      return Array.prototype.slice
        .call(select.options)
        .filter(function (option) {
          return !option.hasAttribute("data-ha-placeholder");
        })
        .map(function (option) {
          return option.value;
        });
    });
    var placeholders = selects.map(function (select) {
      return select.options.length ? select.options[0].textContent : "";
    });

    var selected = selects.map(function () {
      return null;
    });
    var lastMediaPosition = null;

    function matches(variant, choice) {
      for (var i = 0; i < choice.length; i++) {
        if (choice[i] !== null && variant.options[i] !== choice[i]) return false;
      }
      return true;
    }

    function candidates(choice) {
      return variants.filter(function (variant) {
        return matches(variant, choice);
      });
    }

    // Values reachable at optionIndex given only the options BEFORE it.
    // Filtering against later options too would hide values the customer can
    // still legitimately choose, and there would be no way back to them.
    function offerable(optionIndex) {
      var basis = selected.map(function (value, index) {
        return index < optionIndex ? value : null;
      });
      var reach = new Map();
      candidates(basis).forEach(function (variant) {
        var value = variant.options[optionIndex];
        var entry = reach.get(value) || { available: false };
        if (variant.available) entry.available = true;
        reach.set(value, entry);
      });
      return reach;
    }

    function completeVariant() {
      for (var i = 0; i < selected.length; i++) {
        if (selected[i] === null) return null;
      }
      return candidates(selected)[0] || null;
    }

    // A new choice never switches the customer to another variant. It keeps the
    // choice just made, keeps every still-compatible earlier choice in option
    // order, and clears only what genuinely cannot coexist with it.
    function reconcile(changedIndex) {
      // Options before the one just changed stay put: an offerable value is by
      // construction compatible with them. Only later choices can break.
      var kept = selected.map(function (value, index) {
        return index <= changedIndex ? value : null;
      });
      var cleared = [];
      for (var i = changedIndex + 1; i < selected.length; i++) {
        if (selected[i] === null) continue;
        var trial = kept.slice();
        trial[i] = selected[i];
        if (candidates(trial).length) {
          kept[i] = selected[i];
        } else {
          cleared.push(optionNames[i]);
        }
      }
      selected = kept;
      return cleared;
    }

    function autoSelectForced() {
      var changed = true;
      while (changed) {
        changed = false;
        for (var i = 0; i < selected.length; i++) {
          if (selected[i] !== null) continue;
          var values = Array.from(offerable(i).keys());
          if (values.length === 1) {
            selected[i] = values[0];
            changed = true;
          }
        }
      }
    }

    function renderSelects() {
      selects.forEach(function (select, index) {
        var reach = offerable(index);
        var wanted = [];
        valueOrder[index].forEach(function (value) {
          var entry = reach.get(value);
          if (!entry) return; // no Shopify variant exists here, so hide it
          wanted.push({ value: value, available: entry.available });
        });

        // Option values legitimately contain spaces and hyphens, so the redraw
        // signature keeps value and availability in separate fields.
        var signature = wanted
          .map(function (item) {
            return (item.available ? "1" : "0") + item.value;
          })
          .join("");

        if (select.dataset.haSignature !== signature) {
          select.dataset.haSignature = signature;
          var frag = document.createDocumentFragment();
          var placeholder = document.createElement("option");
          placeholder.value = "";
          placeholder.textContent = placeholders[index];
          placeholder.setAttribute("data-ha-placeholder", "");
          frag.appendChild(placeholder);
          wanted.forEach(function (item) {
            var option = document.createElement("option");
            option.value = item.value;
            option.textContent = item.available ? item.value : item.value + " - Sold out";
            option.disabled = !item.available;
            frag.appendChild(option);
          });
          select.replaceChildren(frag);
        }

        select.value = selected[index] === null ? "" : selected[index];
        if (select.value === "" && selected[index] !== null) selected[index] = null;
      });
    }

    function setStatus(message) {
      if (status) status.textContent = message || "";
    }

    function applyQuantityRules(variant) {
      var qty = root.querySelector("[data-ha-qty]");
      var hiddenQty = root.querySelector("[data-ha-form-quantity]");
      if (!qty) return;
      var min = variant && variant.quantityMin ? variant.quantityMin : 1;
      var step = variant && variant.quantityIncrement ? variant.quantityIncrement : 1;
      qty.min = String(min);
      qty.step = String(step);
      if (variant && variant.quantityMax) qty.max = String(variant.quantityMax);
      else qty.removeAttribute("max");

      var current = parseInt(qty.value, 10) || min;
      if (current < min) current = min;
      if (variant && variant.quantityMax && current > variant.quantityMax) current = variant.quantityMax;
      var offset = current - min;
      if (step > 1 && offset % step !== 0) current = min + Math.round(offset / step) * step;
      qty.value = String(current);
      if (hiddenQty) hiddenQty.value = String(current);
    }

    function showVariantMedia(variant) {
      if (!variant || !variant.mediaPosition) return;
      if (variant.mediaPosition === lastMediaPosition) return;
      var thumbs = Array.prototype.slice.call(root.querySelectorAll("[data-ha-thumb]"));
      var thumb = thumbs[variant.mediaPosition - 1];
      if (!thumb) return;
      lastMediaPosition = variant.mediaPosition;
      thumb.click();
    }

    // Colour is enough to preview a garment, but never enough to buy it.
    // Use a partial choice only when every remaining variant has the same
    // assigned image; a size or configuration may legitimately change it.
    function colourPreview() {
      var colourIndex = optionNames.findIndex(function (name) {
        return /^colou?r$/i.test(String(name).trim());
      });
      if (colourIndex < 0 || selected[colourIndex] === null) return null;
      var remaining = candidates(selected);
      var preview = remaining[0];
      if (!preview || !preview.mediaPosition || !preview.image) return null;
      return remaining.every(function (candidate) {
        return candidate.mediaPosition === preview.mediaPosition && candidate.image === preview.image;
      }) ? preview : null;
    }

    function syncUrl(variant) {
      if (!window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        if (variant) url.searchParams.set("variant", String(variant.id));
        else url.searchParams.delete("variant");
        window.history.replaceState({ haVariantId: variant ? variant.id : null }, "", url.toString());
      } catch (error) {}
    }

    function remainingNames() {
      var names = [];
      selected.forEach(function (value, index) {
        if (value === null) names.push(optionNames[index]);
      });
      return names;
    }

    function joinNames(names) {
      if (names.length <= 1) return names.join("");
      return names.slice(0, -1).join(", ") + " and " + names[names.length - 1];
    }

    function apply(clearedNames, changedValue) {
      var variant = completeVariant();
      root.dataset.haSelectedVariantId = variant ? String(variant.id) : "";
      var mediaVariant = variant || colourPreview();
      var purchasable = !!(variant && variant.available);

      if (hiddenId) {
        if (purchasable) {
          hiddenId.value = String(variant.id);
          hiddenId.disabled = false;
        } else {
          hiddenId.disabled = true;
        }
      }

      priceTargets.forEach(function (target) {
        if (variant) target.textContent = variant.price;
        else if (matrix.priceVaries) target.textContent = "From " + matrix.priceMin;
        else target.textContent = matrix.priceMin;
      });

      if (compareTarget) {
        var compare = variant && variant.compareAt;
        compareTarget.textContent = compare || "";
        compareTarget.hidden = !compare;
      }
      if (saveTarget) {
        var save = variant && variant.save;
        saveTarget.textContent = save || "";
        saveTarget.hidden = !save;
      }

      var priceEl = root.querySelector(".price-row [data-ha-price]");
      if (priceEl) priceEl.classList.toggle("price--sale", !!(variant && variant.compareAt));

      if (note) {
        if (!variant) {
          note.textContent = "";
          note.className = "stock-note";
        } else if (variant.available) {
          note.textContent = variant.sku ? "Available to Order - " + variant.sku : "Available to Order";
          note.className = "stock-note stock-note--in";
        } else {
          note.textContent = variant.sku ? "Sold out - " + variant.sku : "Sold out";
          note.className = "stock-note stock-note--order";
        }
      }

      if (barVariant) barVariant.textContent = variant ? variant.title : "";
      if (barImage && mediaVariant && mediaVariant.image) barImage.src = mediaVariant.image;

      submitButtons.forEach(function (button) {
        if (purchasable) {
          button.disabled = false;
          button.textContent = "Add to basket";
        } else if (variant) {
          button.disabled = true;
          button.textContent = "Sold out";
        } else {
          button.disabled = true;
          button.textContent = "Choose options";
        }
      });

      applyQuantityRules(variant);
      showVariantMedia(mediaVariant);
      syncUrl(variant);

      var messages = [];
      if (clearedNames && clearedNames.length && changedValue) {
        messages.push(
          joinNames(clearedNames) +
            (clearedNames.length > 1 ? " cleared. They are" : " cleared. It is") +
            " not available with " +
            changedValue +
            "."
        );
      }
      var remaining = remainingNames();
      if (remaining.length) {
        messages.push("Choose " + joinNames(remaining).toLowerCase() + " to continue.");
      } else if (variant) {
        messages.push(
          variant.title +
            ". " +
            variant.price +
            (variant.available ? ". Available to Order." : ". Sold out.")
        );
      }
      setStatus(messages.join(" "));
      if (root.dataset.haProductVendor === "Diode Dynamics") {
        root.dispatchEvent(new CustomEvent("ha:diode-variant-change"));
      }
    }

    function refresh(clearedNames, changedValue) {
      autoSelectForced();
      renderSelects();
      apply(clearedNames, changedValue);
    }

    function selectFromVariantId(id) {
      var hit = variants.find(function (variant) {
        return String(variant.id) === String(id);
      });
      if (!hit) return false;
      selected = hit.options.slice();
      return true;
    }

    function readUrlVariant() {
      try {
        return new URL(window.location.href).searchParams.get("variant");
      } catch (error) {
        return null;
      }
    }

    selects.forEach(function (select, index) {
      select.addEventListener("change", function () {
        var value = select.value === "" ? null : select.value;
        selected[index] = value;
        var cleared = value === null ? [] : reconcile(index);
        refresh(cleared, value);
      });
    });

    window.addEventListener("popstate", function () {
      var id = readUrlVariant();
      if (!id || !selectFromVariantId(id)) {
        selected = selects.map(function () {
          return null;
        });
      }
      refresh([], null);
    });

    var initialId = readUrlVariant();
    if (initialId) selectFromVariantId(initialId);
    refresh([], null);
  }


  function initQuantity(root) {
    var qty = root.querySelector("[data-ha-qty]");
    var hiddenQty = root.querySelector("[data-ha-form-quantity]");
    if (!qty) return;

    function sync(value) {
      var next = Math.max(1, parseInt(value, 10) || 1);
      qty.value = String(next);
      if (hiddenQty) hiddenQty.value = String(next);
    }

    root.querySelectorAll("[data-ha-qty-step]").forEach(function (button) {
      button.addEventListener("click", function () {
        sync((parseInt(qty.value, 10) || 1) + Number(button.dataset.haQtyStep));
      });
    });

    qty.addEventListener("change", function () {
      sync(qty.value);
    });

    sync(qty.value);
  }

  function initStickyBar(root) {
    var bar = root.querySelector("[data-ha-buy-bar]");
    var anchor = root.querySelector(".buybox .buy-row");
    var form = root.querySelector("[data-ha-product-form]");
    if (!bar || !anchor || !("IntersectionObserver" in window)) return;

    var unpinned = false;
    try { unpinned = sessionStorage.getItem("haBuyBarUnpinned") === "1"; } catch (error) {}

    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle("is-on", passed && !unpinned);
    }, { threshold: 0 }).observe(anchor);

    var toTop = bar.querySelector("[data-ha-bar-top]");
    if (toTop) {
      toTop.addEventListener("click", function () {
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    }

    var unpin = bar.querySelector("[data-ha-bar-unpin]");
    if (unpin) {
      unpin.addEventListener("click", function () {
        unpinned = true;
        bar.classList.remove("is-on");
        try { sessionStorage.setItem("haBuyBarUnpinned", "1"); } catch (error) {}
      });
    }

    var button = bar.querySelector("[data-ha-bar-submit]");
    if (button && form) {
      button.addEventListener("click", function () {
        if (typeof form.requestSubmit === "function") {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    }
  }

  function initFitmentDetailsWhenReady(root) {
    var prose = root.querySelector(".prose");
    var dataNode = prose && prose.querySelector("[data-ha-fitment-data]");
    if (!dataNode) return;
    var data;
    try { data = JSON.parse(dataNode.textContent); } catch (error) { initFitmentDetails(root); return; }
    if (data.vendor === "K&N") {
      if (window.hooniesKnProductFitment) window.hooniesKnProductFitment.initWhenVisible(root, prose, dataNode, data);
      else { var unavailable = document.createElement("p"); unavailable.textContent = "Fitment is unavailable. Contact us with the selected part number before ordering."; prose.appendChild(unavailable); dataNode.remove(); }
      return;
    }
    if (data.vendor === "EBC Brakes" && data.ebcProjectionUrl) { initFitmentDetails(root); return; }
    if (data.universal === true || data.vendor === "Kooks" || data.vendor === "Addictive Desert Designs") { initFitmentDetails(root); return; }
    var pending = document.createElement("p");
    pending.className = "product-fitment-details__check";
    pending.textContent = "Loading vehicle fitment…";
    prose.appendChild(pending);
    if (window.hooniesVehicleData) {
      var loadDetails = function () {
        window.hooniesVehicleData.product(data.productGid, data.productHandle).then(function () {
          if (data.requiredSourceConditionContract) {
            if (!window.hooniesSourceConditionData) throw new Error("SOURCE_CONDITION_DATA_UNAVAILABLE");
            return window.hooniesSourceConditionData.product(data.productGid, data.productHandle);
          }
        }).then(function () {
          if (!root.isConnected) return;
          pending.remove();
          initFitmentDetails(root);
        }).catch(function () {
          pending.textContent = "Vehicle fitment could not be loaded. ";
          var retry = document.createElement("button");
          retry.type = "button";
          retry.textContent = "Retry vehicle fitment";
          retry.addEventListener("click", function () { pending.textContent = "Loading vehicle fitment…"; loadDetails(); });
          pending.appendChild(retry);
        });
      };
      var observer = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        observer.disconnect();
        loadDetails();
      });
      observer.observe(prose);
      return;
    }
    var started = Date.now();
    function ready() {
      if (!root.isConnected) { pending.remove(); return; }
      var index = window.hooniesVehicleFitments;
      var browse = index && index.browseModels;
      if (index && index.projectionEligible === true && index.schemaVersion === "hoonies-staged-vehicle-index.v1" &&
          browse && browse.schemaVersion === "hoonies-existing-theme-models.v1" && index.canonicalReleaseId &&
          browse.canonicalReleaseId === index.canonicalReleaseId && browse.selections) {
        pending.remove();
        initFitmentDetails(root);
      } else {
        var delayed = Date.now() - started >= 15000;
        if (delayed) pending.textContent = "Vehicle fitment is still loading. Please wait before checking your application.";
        window.setTimeout(ready, delayed ? 1000 : 100);
      }
    }
    ready();
  }

  function initFitmentDetails(root) {
    var prose = root.querySelector(".prose");
    if (!prose || prose.querySelector("[data-ha-fitment-details]")) return;
    var dataNode = prose.querySelector("[data-ha-fitment-data]");
    if (!dataNode) return;

    var fitmentData;
    try {
      fitmentData = JSON.parse(dataNode.textContent);
    } catch (error) {
      console.warn("Product fitment data could not be read.", error);
      return;
    }

    if (fitmentData.vendor === "EBC Brakes" && fitmentData.ebcProjectionUrl) {
      if (window.hooniesEbcProductFitment) window.hooniesEbcProductFitment.initWhenVisible(root, prose, dataNode, fitmentData);
      else { var unavailable = document.createElement("p"); unavailable.textContent = "Fitment is unavailable. Contact us with your selected kit part number before ordering."; prose.appendChild(unavailable); dataNode.remove(); }
      return;
    }
    if (fitmentData.vendor === "Kooks" && window.hooniesKooksProductFitment) {
      window.hooniesKooksProductFitment.init(root, prose, dataNode, fitmentData);
      return;
    }
    if (fitmentData.vendor === "Addictive Desert Designs") {
      if (window.hooniesAddProductFitment) {
        window.hooniesAddProductFitment.init(root, prose, dataNode, fitmentData);
      } else {
        var addSection = document.createElement("section");
        addSection.className = "product-fitment-details";
        addSection.setAttribute("data-ha-fitment-details", "");
        var addHeading = document.createElement("h2");
        addHeading.textContent = "Fitment";
        var addNotice = document.createElement("p");
        addNotice.textContent = "Vehicle fitment is unavailable. Contact us with your vehicle and selected part number before ordering.";
        addSection.appendChild(addHeading);
        addSection.appendChild(addNotice);
        prose.appendChild(addSection);
        dataNode.remove();
      }
      return;
    }
    var supplierNodes = extractSupplierFitmentNodes(prose);
    var currentSection = null;
    var conditionRenderSequence = 0;
    dataNode.remove();
    function render() {
      if (!root.isConnected) return;
      var conditionToken = ++conditionRenderSequence;
      if (currentSection) currentSection.remove();
      var input = root.querySelector("[data-ha-variant-id]");
      var selectedId = Object.prototype.hasOwnProperty.call(root.dataset, "haSelectedVariantId") ? root.dataset.haSelectedVariantId :
        input && !input.disabled ? input.value : new URL(window.location.href).searchParams.get("variant") || "";
      var selected = String(selectedId).replace(/^gid:\/\/shopify\/ProductVariant\//, "");
      var selectedVariants = (fitmentData.variants || []).filter(function (variant) {
        return String(variant.id || "").replace(/^gid:\/\/shopify\/ProductVariant\//, "") === selected;
      });
      if (!selectedVariants.length && fitmentData.variants.length === 1) selectedVariants = fitmentData.variants;
      var selectedIsUniversal = fitmentData.universal === true || (fitmentData.vendor === "Diode Dynamics" && selectedVariants.length === 1 && selectedVariants[0].universal === true);
      var needsSelection = !selectedIsUniversal && fitmentData.variants.length > 1 && !selectedVariants.length;
      var currentFitmentData = Object.assign({}, fitmentData, {variants:selectedVariants,universal:selectedIsUniversal});
    var sourceConditionsPending = false;
    var conditionReader = window.hooniesSourceFitmentConditions;
    var conditionIndex = window.hooniesVehicleFitments;
    var conditionBrowse = conditionIndex && conditionIndex.browseModels;
    var conditionPromises = [];
    if (conditionReader && conditionReader.guardSchemaVersion === "hoonies-bound-source-condition-guard.v1" &&
        typeof conditionReader.prepare === "function" && typeof conditionReader.status === "function" &&
        conditionIndex && conditionIndex.projectionEligible === true && conditionBrowse && conditionBrowse.selections) {
      var selectedConditionIds = new Set(selectedVariants.map(function (variant) {
        var id = String(variant.id || "");
        return /^\d+$/.test(id) ? "gid://shopify/ProductVariant/" + id : id;
      }));
      Object.keys(conditionBrowse.selections).forEach(function (key) {
        var selection = conditionBrowse.selections[key];
        if (!selection || selection.scope !== "application" || selection.canonicalReleaseId !== conditionIndex.canonicalReleaseId) return;
        var product = (selection.products || []).find(function (row) { return row.productGid === currentFitmentData.productGid && row.handle === currentFitmentData.productHandle; });
        if (!product || !(product.variantGids || []).some(function (id) { return selectedConditionIds.has(id); }) ||
            !currentFitmentData.requiredSourceConditionContract && !product.sourceConditions) return;
        var context = {canonicalReleaseId: conditionIndex.canonicalReleaseId, selectionId: key,
          requiredSchema: currentFitmentData.requiredSourceConditionContract || null, guard: selection.sourceConditionGuard};
        var promise = conditionReader.prepare(product, context);
        if (conditionReader.status(product, context) === "pending") { sourceConditionsPending = true; conditionPromises.push(promise); }
      });
    }
    if (conditionPromises.length) Promise.all(conditionPromises).then(function () {
      if (root.isConnected && conditionToken === conditionRenderSequence) render();
    });
    var authorityGroups = buildCanonicalFitmentGroups(currentFitmentData);
    var section = document.createElement("section");
    section.className = "product-fitment-details";
    section.setAttribute("data-ha-fitment-details", "");
    section.setAttribute("aria-labelledby", "product-fitment-details-heading");

    var heading = document.createElement("h2");
    heading.id = "product-fitment-details-heading";
    heading.className = "product-fitment-details__heading";
    heading.textContent = "Fitment";
    section.appendChild(heading);

    var note = document.createElement("p");
    note.className = "product-fitment-details__check";
    section.appendChild(note);

    if (needsSelection) {
      note.textContent = "Choose a product option to see its exact vehicle fitment.";
    } else if (sourceConditionsPending) {
      note.textContent = "Checking the supplied fitment conditions…";
    } else if (authorityGroups.length) {
      note.textContent = fitmentData.labels.checkedNote;
      renderCanonicalFitmentTable(section, authorityGroups);
    } else if (currentFitmentData.universal === true) {
      section.classList.add("product-fitment-details--universal");
      note.textContent = "This is a universal product. Check the dimensions, mounting points and connections against your setup before ordering.";
    } else if (supplierNodes.length) {
      section.classList.add("product-fitment-details--review");
      note.textContent = fitmentData.labels.supplierNote;
    } else {
      section.classList.add("product-fitment-details--review");
      note.textContent = "No exact vehicle fitment is currently published for this product. Contact us with your make, model, engine and year before ordering.";
    }

    if (supplierNodes.length) {
      var supplierDetails = document.createElement("details");
      supplierDetails.className = "product-fitment-supplier";
      var supplierSummary = document.createElement("summary");
      supplierSummary.textContent = "Supplier fitment notes";
      supplierDetails.appendChild(supplierSummary);
      var supplierBody = document.createElement("div");
      supplierBody.className = "product-fitment-supplier__body";
      supplierNodes.forEach(function (node) {
        supplierBody.appendChild(node);
      });
      supplierDetails.appendChild(supplierBody);
      section.appendChild(supplierDetails);
    }

    prose.appendChild(section);
      currentSection = section;
    }
    render();
    root.addEventListener("change", function (event) {
      if (event.target && event.target.matches("[data-ha-option-select]")) window.queueMicrotask(render);
    });
    window.addEventListener("popstate", function () { window.queueMicrotask(render); });
  }

  function extractSupplierFitmentNodes(prose) {
    var headings = Array.prototype.slice.call(prose.querySelectorAll("h2, h3, h4"));
    var heading = headings.find(function (candidate) {
      return candidate.textContent.replace(/\s+/g, " ").trim().toLowerCase().replace(/:$/, "") === "fitment";
    });
    if (!heading) return [];

    var headingLevel = Number(heading.tagName.slice(1));
    var nodes = [];
    var cursor = heading.nextElementSibling;
    while (cursor && !cursor.hasAttribute("data-ha-fitment-data")) {
      var next = cursor.nextElementSibling;
      var cursorLevel = /^H[1-6]$/.test(cursor.tagName) ? Number(cursor.tagName.slice(1)) : 99;
      if (cursorLevel <= headingLevel) break;
      nodes.push(cursor);
      cursor = next;
    }
    heading.remove();
    nodes.forEach(function (node) { node.remove(); });
    return nodes;
  }

  function buildCanonicalFitmentGroups(data) {
    var index = window.hooniesVehicleFitments;
    var browse = index && index.browseModels;
    if (!index || index.projectionEligible !== true || index.schemaVersion !== "hoonies-staged-vehicle-index.v1" ||
        !browse || browse.schemaVersion !== "hoonies-existing-theme-models.v1" ||
        !index.canonicalReleaseId || browse.canonicalReleaseId !== index.canonicalReleaseId || !browse.selections) return [];
    var variants = new Map();
    (Array.isArray(data.variants) ? data.variants : []).forEach(function (variant) {
      var id = String(variant.id || "");
      if (/^\d+$/.test(id)) id = "gid://shopify/ProductVariant/" + id;
      if (/^gid:\/\/shopify\/ProductVariant\/\d+$/.test(id)) variants.set(id, variant);
    });
    var groups = new Map();
    Object.keys(browse.selections).forEach(function (key) {
      var selection = browse.selections[key];
      if (!selection || selection.scope !== "application" || selection.canonicalReleaseId !== index.canonicalReleaseId ||
          !selection.modelId || !selection.makeLabel || !selection.modelLabel || !selection.yearLabel) return;
      var product = (Array.isArray(selection.products) ? selection.products : []).find(function (candidate) {
        return candidate.productGid === data.productGid && candidate.handle === data.productHandle;
      });
      if (!product) return;
      var matching = (Array.isArray(product.variantGids) ? product.variantGids : []).filter(function (id) { return variants.has(id); });
      if (!matching.length) return;
      var sourceConditions = [];
      if (data.requiredSourceConditionContract || product.sourceConditions) {
        var conditionReader = window.hooniesSourceFitmentConditions;
        sourceConditions = conditionReader && conditionReader.guardSchemaVersion === "hoonies-bound-source-condition-guard.v1" &&
          typeof conditionReader.match === "function" && conditionReader.match(product, matching, variants, {
          canonicalReleaseId: index.canonicalReleaseId, selectionId: key,
          requiredSchema: data.requiredSourceConditionContract || null, guard: selection.sourceConditionGuard
        });
        if (!sourceConditions || !sourceConditions.length) return;
      }
      var groupId = selection.makeId + ":" + selection.modelId;
      if (!groups.has(groupId)) groups.set(groupId, {
        baseId: groupId, make: selection.makeLabel, model: selection.modelLabel,
        years: data.labels.applicationDetail, applications: []
      });
      groups.get(groupId).applications.push({
        authorityId: key,
        engine: sourceConditions.length ? "" : selection.yearLabel,
        sourceConditions: sourceConditions,
        variants: Array.from(new Set(matching.map(function (id) { return variantFitmentLabel(variants.get(id)); }).filter(Boolean))).sort()
      });
    });
    return Array.from(groups.values()).map(function (group) {
      group.applications.sort(function (a, b) { return a.engine.localeCompare(b.engine, undefined, { numeric: true }); });
      group.searchText = [group.make, group.model].concat(group.applications.map(function (application) {
        var conditionText = (application.sourceConditions || []).map(function (view) {
          return [view.engine, view.years].concat(view.conditions.map(function (line) { return line.label + " " + line.text; })).join(" ");
        });
        return [application.engine].concat(conditionText, application.variants).join(" ");
      })).join(" ").toLowerCase();
      return group;
    }).sort(function (a, b) {
      return [a.make, a.model].join(" ").localeCompare([b.make, b.model].join(" "), undefined, { numeric: true });
    });
  }

  function variantFitmentLabel(variant) {
    var sku = String(variant.sku || "").trim();
    var title = String(variant.title || "").trim();
    if (sku) return "SKU " + sku;
    if (title && title.toLowerCase() !== "default title") return title;
    return "";
  }

  function renderCanonicalFitmentTable(section, groups) {
    var applicationCount = groups.reduce(function (total, group) { return total + group.applications.length; }, 0);
    if (groups.length >= 4 || applicationCount >= 12) {
      var search = document.createElement("label");
      search.className = "product-fitment-search";
      search.innerHTML =
        "<span class=\"visually-hidden\">Search fitment</span>" +
        "<input type=\"search\" inputmode=\"search\" autocomplete=\"off\" placeholder=\"Search make, model, engine or year\">" +
        "<small aria-live=\"polite\">" + String(groups.length) + (groups.length === 1 ? " vehicle shown" : " vehicles shown") + "</small>";
      section.appendChild(search);
    }

    var table = document.createElement("div");
    table.className = "product-fitment-table";
    groups.forEach(function (group) {
      var details = document.createElement("details");
      details.className = "product-fitment-model";
      details.dataset.searchText = group.searchText;

      var summary = document.createElement("summary");
      summary.className = "product-fitment-model__summary";
      var name = document.createElement("span");
      name.className = "product-fitment-model__name";
      name.textContent = [group.make, group.model].filter(Boolean).join(" ");
      var years = document.createElement("span");
      years.className = "product-fitment-model__years";
      years.textContent = group.years || "Approved application";
      var count = document.createElement("span");
      count.className = "product-fitment-model__count";
      count.textContent = String(group.applications.length) + (group.applications.length === 1 ? " fitment" : " fitments");
      var toggle = document.createElement("span");
      toggle.className = "product-fitment-model__toggle";
      toggle.setAttribute("aria-hidden", "true");
      summary.appendChild(name);
      summary.appendChild(years);
      summary.appendChild(count);
      summary.appendChild(toggle);
      details.appendChild(summary);

      var list = document.createElement("ul");
      list.className = "product-fitment-applications";
      group.applications.forEach(function (application) {
        var item = document.createElement("li");
        item.className = "product-fitment-application";
        if (application.sourceConditions && application.sourceConditions.length) {
          window.hooniesSourceFitmentConditions.append(item, application.sourceConditions);
        } else {
          var engine = document.createElement("span");
          engine.textContent = application.engine || "Vehicle application";
          item.appendChild(engine);
        }
        if (application.variants.length) {
          var variants = document.createElement("small");
          variants.textContent = application.variants.join(", ");
          item.appendChild(variants);
        }
        list.appendChild(item);
      });
      details.appendChild(list);
      table.appendChild(details);
    });
    section.appendChild(table);

    var search = section.querySelector(".product-fitment-search");
    if (!search) return;
    var input = search.querySelector("input");
    var status = search.querySelector("small");
    input.addEventListener("input", function () {
      var query = input.value.replace(/\s+/g, " ").trim().toLowerCase();
      var shown = 0;
      table.querySelectorAll(".product-fitment-model").forEach(function (model) {
        var matches = !query || model.dataset.searchText.indexOf(query) !== -1;
        model.hidden = !matches;
        model.open = Boolean(query && matches);
        if (matches) shown += 1;
      });
      status.textContent = String(shown) + (shown === 1 ? " vehicle shown" : " vehicles shown");
    });
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }


  function initSubnav(root) {
    var links = Array.prototype.slice.call(root.querySelectorAll(".pdp-subnav a, .pdp-sidenav a"));
    if (!links.length || !("IntersectionObserver" in window)) return;

    var map = new Map();
    links.forEach(function (link) {
      var target = root.querySelector(link.getAttribute("href"));
      if (target) map.set(target, link);
    });

    map.forEach(function (link, target) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          links.forEach(function (item) {
            item.removeAttribute("aria-current");
          });
          link.setAttribute("aria-current", "true");
        });
      }, { rootMargin: "-30% 0px -60% 0px" }).observe(target);
    });
  }

  function boot() {
    document.querySelectorAll("[data-ha-product]").forEach(initProduct);
  }

  if (document.readyState !== "complete") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector("[data-ha-product]");
    if (root) initProduct(root);
  });
})();
